export const fetchServiceLevelData = async () => {
  try {
    // Call api here
    //const response = await fetch("https://your api url");
    const data = await getMockedData();
    return data;
  } catch (e) {
    console.log(e);
  }
};

const getMockedData = () => {
  return [
    {key: 1, value: 'N', name: 'NFG'},
    {key: 2, value: 'I', name: 'NFG INTL'},
    {key: 3, value: 'FF', name: 'FRESH FAST'},
    {key: 4, value: 'S', name: 'SOUTHWEST STANDARD'}
  ];

}



// WEBPACK FOOTER //
// ./src/api/serviceLevelDataApi.js